export default __webpack_public_path__ + "static/media/loginimage.86562b2e.jpg";